import { lazy } from "react";
import { appModulesToRequiredUserRoles } from "@jugl-web/domain-resources/common/consts";
import { PageNavParams } from "@web-src/modules/navigation/types";
import { ModulePagesConfig } from "@web-src/modules/navigation/types/ModulePagesConfigs";
import { SubscriptionPlanModuleId } from "@jugl-web/rest-api";

const DrivePage = lazy(() => import("./DrivePage"));

export type DrivePagesNavigationParams = {
  driveDrive: PageNavParams<
    never,
    {
      directoryId?: string;
      directoryName?: string;
      openedFile?: string;
      path?: string;
      full_path?: string;
    }
  >;
};

export const drivePagesNavigationConfig: ModulePagesConfig<DrivePagesNavigationParams> =
  {
    driveDrive: {
      element: <DrivePage />,
      path: "drive",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.drive,
      requiredModules: [SubscriptionPlanModuleId.drive],
    },
  };
